export default __webpack_public_path__ + "static/media/section1-item-2.cc9267fb.png";